/* istanbul ignore file */
import { DEFAULT_WHITELABEL_ID } from '../helpers/constants';
import useWhitelabelQuery from './useWhitelabelQuery';

export default function useDefaultWhitelabel() {
  return useWhitelabelQuery({
    whitelabelId: DEFAULT_WHITELABEL_ID,
  });
}
